<script>
  import { Link, useLocation } from "svelte-navigator";
  export let href = "";
  export let onClick = null;
  export let selected = false;
  export let style = "";
  export let keepParams = false;
  export let minHeight = null;
  export let black = false;
  export let border = false;
  export let clickable = true;

  const location = useLocation();
  $: effectiveHref =
    keepParams && href && $location.search
      ? `${href}${$location.search}`
      : href;
</script>

{#if href}
  <Link to={effectiveHref} class="info_card_link">
    <article
      class="info_card"
      class:selected
      class:info_card_black={black}
      class:info_card_border={border}
      style={minHeight ? `min-height: ${minHeight}; ${style}` : style}
    >
      <slot />
    </article>
  </Link>
{:else}
  <article
    class="info_card"
    class:selected
    class:info_card_black={black}
    class:info_card_border={border}
    class:clickable
    role={clickable ? "button" : undefined}
    style={minHeight ? `min-height: ${minHeight}; ${style}` : style}
    on:click={onClick}
    on:keydown={(event) => {
      if (event.key === "Enter" || event.key === " ") onClick?.(event);
    }}
  >
    <slot />
  </article>
{/if}

<style>
  :global(.info_card_link) {
    text-decoration: none;
    color: inherit;
    display: block;
  }

  :global(.info_card_link:hover .info_card) {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
    transition: all 0.2s ease;
  }

  .info_card.selected {
    border: 1px solid #000;
  }

  .info_card {
    width: 100%;
    min-width: 12.5rem;
    min-height: 5.5rem;
    border-radius: 0.3125rem;
    background: var(--pax-white, #f9fbff);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0.69rem 0.81rem 0.78rem 0.81rem;
    gap: 0.5rem;
  }

  .info_card.clickable:hover {
    cursor: pointer;
  }

  .info_card_black {
    background: var(--pax-black, #000);
    color: var(--pax-white, #fff);
  }
  .info_card_border {
    border: 1px solid #d9d9d9;
  }
</style>
